<template>
    <Library title="Character Library" addLabel="Add Character" @add-item="addCharacter">
        <CharacterList v-bind:characters="characters" />
        <Button v-on:click="removeSelected">Remove Selected</Button>
    </Library>
</template>

<script lang="ts">
import { mapActions, mapGetters, mapState } from 'vuex';

import CharacterList from './CharacterList.vue';
import Library from '@/components/common/library/Library.vue';

export default {
    components: {
        CharacterList: CharacterList,
        Library: Library,
    },
    computed: {
        ...mapGetters('gamestate/', {
            selectedTokenId: 'selectedTokenId',
        }),
        ...mapState('live', {
            director: 'director',
        }),
        ...mapState('library', {
            characters: 'characters',
        }),
    },
    created: function() {
        this.getCharacters();
    },
    methods: {
        removeSelected: function() {
            const selectedCharacterId = this.selectedTokenId;
            console.log(`character/tokenID: ${selectedCharacterId}`);
            this.director.removeCharacter(selectedCharacterId);
        },
        ...mapActions('library', {
            addCharacter: 'addCharacter',
            getCharacters: 'getCharacters',
        }),
    },
};
</script>
